import {Injectable} from '@angular/core';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {Observable} from 'rxjs';
import {UmpirePageType} from '@tisa-group/models';

@Injectable()
export class PageTypeService implements CrudService<UmpirePageType> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpirePageType[]>> {
    return this.http
      .get('/page_types', {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePageType>> {
    return this.http
      .get(`/page_types/${fetchIdentifier}`, {params: objectToHttpParams(params)})
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpirePageType>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePageType>> {
    return this.http
      .post<JsonApiResponse<UmpirePageType>>('/page_types', serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpirePageType>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpirePageType>> {
    return this.http
      .patch<JsonApiResponse<UmpirePageType>>(
        `/page_types/${body.id}`,
        serialize({stuff: body}),
        {
          params: objectToHttpParams(params),
        },
      )
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/page_types/${id}`);
  }
}
